import React, { useEffect } from 'react';
import FacetViewModel from 'Shared/Facet/FacetViewModel.type';
import DoubleSlider from 'Shared/SharedComponents/atoms/DoubleSlider';

type PropType = { filter: FacetViewModel; updateValue: (filter: FacetViewModel) => void };

const PriceSlider = ({ filter, updateValue }: PropType) => {
  const updatePriceRange = (selectedMin: number, selectedMax: number) => {
    updateValue({
      ...filter,
      minSelected: selectedMin,
      maxSelected: selectedMax,
    });
  };
  
  return (  
    <DoubleSlider
      min={filter.min}
      max={filter.max}
      selectedMin={filter.minSelected}
      selectedMax={filter.maxSelected}
      updateValue={updatePriceRange}
    />
  );
};

export default PriceSlider;
